import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

// 引入你的页面组件
// import Home from '../pages/home/home.vue';
// import About from '../views/About.vue';
// import { useStore } from '../stores/user';
// import Download from '@/pages/download/download.vue';
import { isRunApp } from '@/scripts/assets/scripts/utils';
const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/pages/home/home.vue'),
    },
    // {
    //     path: '/download',
    //     name: 'download',
    //     component: () => import('@/pages/download/download.vue'),
    // },
];

const buildApp = import.meta.env.VITE_PLATFORM === 'android';
console.log("是否APP模式构建", buildApp);
console.log("是否App 运行", isRunApp());

// 创建 router 实例
const router = createRouter({
    //history: createWebHistory(import.meta.env.BASE_URL),
    history: buildApp ? createWebHashHistory() : createWebHistory(import.meta.env.BASE_URL),//android 打包
    routes,
});

router.beforeEach((to, from, next) => {
    // const userStore = useStore();
    //console.log("页面跳转", to, from);
    const matched = to.matched.length > 0;
    if (!matched) {
        // 如果路径未匹配任何路由，重定向到首页
        next({ path: '/' });
    } else {
        // 例如，判断用户是否登录，若未登录则跳转到登录页
        next();
    }
});

export default router;
